import 'css-chunksrc/client/pages/projectPage/budgetPage/expensesBreakdownByExpenseType/styles.scss';export default {
  "expensesBreakdownByExpenses": "_expensesBreakdownByExpenses_15fdg_1",
  "budgetBar": "_budgetBar_15fdg_10",
  "legend": "_legend_15fdg_33",
  "col": "_col_15fdg_41",
  "legendItem": "_legendItem_15fdg_49",
  "legendColor": "_legendColor_15fdg_58",
  "light": "_light_15fdg_64"
};